export const manifest = {
  screens: {
    scr_3vvxx8: { name: "Home", route: "/" },
  },
}
